import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLegacyModule } from 'studio-components';

@Component({
  selector: 'studio-file-validator',
  standalone: true,
  imports: [ButtonLegacyModule, CommonModule],
  templateUrl: './file-validator.component.html',
  styleUrls: ['./file-validator.component.scss'],
})
export class FileValidatorComponent {
  @ViewChild('fileInput') input: ElementRef<HTMLInputElement>;

  @Input() public uploadButtonText: string;
  @Input() public updateButtonText = 'Update';
  @Input() public uniqueId: string;
  @Input() public fileType: string;
  @Input() public filePreview: string;
  @Input() public disableRemoveButton = false;

  @Output() public fileChanged = new EventEmitter<FileList>();
  @Output() public fileCleared = new EventEmitter<void>();

  protected openFileBrowser() {
    this.input.nativeElement.click();
  }

  protected fileSelected(target: HTMLInputElement) {
    if (target.value) {
      this.fileChanged.emit(target.files);
    }
  }

  protected removeFile() {
    this.fileCleared.emit();
    this.input.nativeElement.value = '';
  }
}
